import type { PostHog } from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import React from "react";

/**
 * Google Tag Manager handle cookies consent and when the user accepts the cookies
 * it will load the PostHog script asynchronously.
 */
const getPosthogInstance = () => {
	// biome-ignore lint/style/noRestrictedGlobals: posthog instance is stored in window
	if ("posthog" in window) {
		// biome-ignore lint/style/noRestrictedGlobals: posthog instance is stored in window
		return window.posthog as PostHog;
	}

	return undefined;
};

export const AnalyticsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [posthog, setPosthog] = React.useState(getPosthogInstance);

	React.useEffect(() => {
		const handler = (event: Event) => {
			if (event.target instanceof HTMLScriptElement) {
				setPosthog(getPosthogInstance());
			}
		};

		/**
		 * Listen to the `load` event of injected scripts and update the PostHog instance on any script load.
		 * If the window.posthog value does not change the useState hook won't trigger a re-render.
		 */
		document.head.addEventListener("load", handler, true);

		return () => {
			document.head.removeEventListener("load", handler, true);
		};
	}, []);

	return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
